module.exports = __webpack_public_path__ + "static/media/logo-neopharm.e5ab7837.png";